import clemente from '../../../img/fightersStoryImg/cleme-wbc.webp'
import pasquale from '../../../img/fightersStoryImg/maestro-pasquale.webp'
import maestro from '../../../img/fightersStoryImg/img-maestro.webp'
import raffaele from '../../../img/fightersStoryImg/raffaele-fighter.webp'
import igor from '../../../img/fightersStoryImg/igor-fighter.webp'
import annamaria from '../../../img/fightersStoryImg/annamaria.webp'
import andrea from '../../../img/fightersStoryImg/andrea.webp'
import gennaro from '../../../img/fightersStoryImg/gennaro.webp'
import valentina from '../../../img/fightersStoryImg/valentina.webp'

export const FightersData = [
    {
        id: 9,
        img: valentina,
        name: "Valentina Cancello",
        descriptions: {
            1: 'Height: 160cm | Weight: 46/48kg',
            2: 'Amatori: 12 match | 10 vittorie',
            3: '2 volte Campionessa Italiana WBC Junior',
            4: '2 volte Campionessa Europea WBC Junior',
            5: '2 volte Campionessa Mediterranea WBC Junior',
            6: 'Professionisti: 5 match | 5 vittorie',
            7: 'Campionessa WBC Muay Thai Mediterranean'
        },
        link: "https://www.instagram.com/valentinacancello/"
    },
    {
        id: 0,
        img: clemente,
        name: "Clemente Verdicchio",
        descriptions: {
            1: 'Height: 184cm | Weight: 70kg',
            2: 'Match: 18 vittorie | 4 losses',
            3: 'European semi pro Muay thai Champion Wmo',
            4: 'Italian professional Champion muay thai Wmo cat 69.800',
            5: 'Italian professional Champion Muay thai WBC cat 69.800'
        },
        link: "https://www.instagram.com/verdicchio.clemente/"
    },
    {
        id: 1,
        img: pasquale,
        name: "Pasquale Amoroso",
        descriptions: {
            1: 'Campione mondiale professionisti Wmo cat 66,700 anno 2022',
            2: 'Campione mondiale professionisti Wmo cat 66,700 anno 2022',
            3: 'Campione mondiale professionisti Wmo cat 66,700 anno 2022',
            4: 'Campione italiano professionisti Muay thai Kombat League cat 63.500 kg anno 2019'
        },
        link: "https://www.instagram.com/pasqualegamoroso/"
    },
    {
        id: 3,
        img: maestro,
        name: "Mario Vivenzio",
        descriptions: {
            1: 'Allenatore Muay thai anno 2010 F.I.K.B',
            2: 'Istruttore Muay thai anno 2012 F.I.K.B',
            3: 'X khan Muay boran Wmo anno 2020',
            4: 'Esperienza decennale nei migliori camp thailandesi',
            5: 'Seminari internazionali con top trainer di livello mondiale',
            6: 'Professional cutman team catizone'
        },
        link: "https://www.instagram.com/mario__vivenzio/"
    },
    {
        id: 4,
        img: igor,
        name: "Igor Kozak",
        descriptions: {
            1: 'Campione italiano professionisti K1 wtka cat 71 kg anno 2016'
        },
        link: ""
    },
    {
        id: 5,
        img: raffaele,
        name: "Raffaele Minichino",
        descriptions: {
            1: 'Campione italiano professionisti Muay thai Kombat League cat 67 kg anno 2018'
        },
        link: ""
    },
    {
        id: 6,
        img: annamaria,
        name: "Annamaria Salvati",
        descriptions: {
            1: 'Height: 163cm | Weight: 48kg',
            2: 'Match: 10 wins | 0 losses'
        },
        link: "https://www.instagram.com/annamariasalvatii/"
    },
    {
        id: 7,
        img: andrea,
        name: "Andrea Franzese",
        descriptions: {
            1: 'Height: 182cm | Weight: 68kg',
            2: 'Match: 10 wins | 3 losses'
        },
        link: "https://www.instagram.com/andreafranzese46/"
    },
    {
        id: 8,
        img: gennaro,
        name: "Gennaro De Meo",
        descriptions: {
            1: 'Height: 180cm | Weight: 70kg',
            2: 'Match: 10 wins | 3 losses',
            3: 'Wmo pro am world Champion'
        },
        link: "https://www.instagram.com/gennyjericho/"
    }
]